export default __webpack_public_path__ + "static/media/utkarsha.c38f49d8.jpg";